import * as Colours from "../../../../globalStyles/administratorColors";

export const body = {
    paddingTop: "20px",
    paddingRight: "30px"
};

export const columnRight = {
    textAlign: "right"
};

export const counter = {
    textAlign: "right",
    color: "red"
};

export const cardStyle = {
    backgroundColor: Colours.primary,
    color: "white"
};

export const editNameSection = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
};

export const editNameTextbox = {
    width: "100%"
};

export const fileSection = {
    color: "grey"
};

export const orderSection = {
    display: "flex",
    flexDirection: "row",
    columnGap: "10px",
    alignItems: "center"
};
